export const LangById: { [Name: string]: string} = {
    "1": "nb-no",
    "2": "en",
    "3": "nn-no",
    "8": "sv"
}